import { render, staticRenderFns } from "./DepositAnswer.component.vue?vue&type=template&id=2113a950&scoped=true&"
import script from "./DepositAnswer.component.vue?vue&type=script&lang=js&"
export * from "./DepositAnswer.component.vue?vue&type=script&lang=js&"
import style0 from "./DepositAnswer.component.vue?vue&type=style&index=0&id=2113a950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2113a950",
  null
  
)

export default component.exports